import appendReservation from './appendReservation';
import updateReservation from './updateReservation';

export default (sheetId, attendee) => {
    if (attendee.attendeeId) {
        return updateReservation(sheetId, attendee);
    }

    return appendReservation(sheetId, attendee);
};



// WEBPACK FOOTER //
// ./src/event/upsertReservation.js